import { render, staticRenderFns } from "./storeroles.vue?vue&type=template&id=4f954942"
import script from "./storeroles.vue?vue&type=script&lang=js"
export * from "./storeroles.vue?vue&type=script&lang=js"
import style0 from "./storeroles.vue?vue&type=style&index=0&id=4f954942&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports